
Vue.component("course_note_panel", {
    props: {
        player: {
            required: true,
        },
        note_info: {
            type: Object,
            required: true,
        },
        base_url: {
            type: String,
            default: "",
        },
        if_this_tab: {
            type: Boolean,
            default: false,
        },
        length: {
            type: Number,
        },
        has_login: {
            type: Boolean,
            default: true
        }
    },
    mounted() {
        window.course = this;
    },
    data() {
        return {
            page: 1,
            size: 50,
            noteList: [],
            noteid: "",
            addLoading: false,
            screenShotLoading: false,
            requestStatus: false,
            canAddNote: false,// 能否添加笔记
        };
    },
    watch: {
        note_info: {
            handler(newVal, oldVal) {
                this.initData()
            },
            deep: true,
            immediate: true,
        },
        has_login: {
            handler(newVal, oldVal) {
                this.initData()
            },
            immediate: true,
        },
        player: {
            handler(newVal, oldVal) {
                this.canAddNote = (newVal && newVal.videoId) || (newVal && this.isLive) || (newVal && newVal.urls)
            },
            immediate: true,
            // deep: true,//m3u8会报错堆栈溢出
        }
    },
    computed: {
        //是否是直播笔记
        isLive() {
            return this.note_info.noteType == 'live'
        },
    },
    methods: {
        initData() {
            // console.log('note_info', this.note_info)
            this.noteid = this.getQueryVariable("noteId");
            this.has_login && this.getNoteList(this.noteid || "");
        },
        //获取笔记列表
        getNoteList(id) {
            // console.log('获取笔记列表', this.note_info)
            //微课不用判断resourceId，mooc、spoc需要判断resourceId
            // if (!this.note_info.resourceId && this.note_info.noteType != 'live') return Promise.reject()
            return new Promise((resolve, reject) => {
                // 增加ready字段判断是否可获取列表
                if (!this.note_info.ready) return resolve()
                let param = { ...this.note_info }
                delete param.defaultImage
                API.reqCourseNoteList({
                    pageIndex: this.page,
                    pageSize: this.size,
                    orderBy: this.isLive ? 'modifyTime' : "pointIn",
                    isDesc: this.isLive,
                    ...param,
                })
                    .then((res) => {
                        if (res.statusCode === config.eduSuccessCode) {
                            this.noteList = res.data.items || [];
                            // 修改为后端排序
                            // this.noteList = res.data.items.sort((pre, cur) => {
                            //   return pre.pointIn - cur.pointIn;
                            // });
                            this.$emit("update:length", this.noteList.length);
                            if (id) {
                                //打开该id聚焦
                                this.noteList.forEach((el, i) => {
                                    if (el.id == id) {
                                        //添加后默认开启编辑
                                        this.editNoteHandel(i, true);
                                        this.playerSeek(el)
                                    }
                                });
                            }
                            resolve(res.data.items);
                        } else {
                            reject(res);
                        }
                        this.$emit('getlist', this.noteList)
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        //判断图片是否全黑
        isBase64ImageAllBlack(base64Image) {
            return new Promise((res, rej) => {
                if (!base64Image) res(true)
                // 将Base64解码为图像
                var img = new Image();
                img.src = base64Image;
                // 等待图像加载完成后进行处理
                img.onload = function () {
                    var canvas = document.createElement('canvas');
                    canvas.width = img.width;
                    canvas.height = img.height;
                    var context = canvas.getContext('2d');
                    context.drawImage(img, 0, 0, img.width, img.height);
                    // 获取图像的像素数据
                    var imageData = context.getImageData(0, 0, canvas.width, canvas.height);
                    // 检查每个像素是否为黑色
                    let flag = true
                    for (var i = 0; i < imageData.data.length; i += 4) {
                        if (imageData.data[i] !== 0 || imageData.data[i + 1] !== 0 || imageData.data[i + 2] !== 0) {
                            // 如果存在非黑色的像素，则返回false
                            flag = false
                        }
                    }
                    res(flag)
                };
            })
        },
        imageToBase64(url) {
            return new Promise((resolve) => {
                var xhr = new XMLHttpRequest();
                xhr.open("GET", url);
                xhr.responseType = "blob";
                xhr.onload = function () {
                    var reader = new FileReader();
                    reader.onloadend = function () {
                        var base64data = reader.result;
                        resolve(base64data);
                    };
                    reader.readAsDataURL(xhr.response);
                };
                xhr.send();
            })
        },
        // 添加笔记
        addNoteHandel() {
            const that = this
            if (!that.has_login) return
            that.noteList.map((el, i) => {
                if (el.editState) {
                    that.addNoteSubmit(i)
                }
            })

            if ((!this.player || !this.player.src) && !this.player.urls) {
                return this.$message.info("未检测到视频");
            }
            if (this.noteList.length >= this.size) {
                return this.$message.info(`最多添加${this.size}条笔记`);
            }
            this.addLoading = true;
            this.screenShotLoading = true
            let noteId = ''
            let pointIn = parseInt(this.isLive ? 0 : this.player.currentTime * 10000000) || 0
            this.videoScreenShot().then(async (src) => {
                // console.log("base64--",src)
                //直播移动端无法抽取关键帧或者关键帧为黑屏的时候使用封面作为关键帧图片
                let isAllBlank = await that.isBase64ImageAllBlack(src)
                let defaultImage = this.note_info.defaultImage
                if (defaultImage) {
                    defaultImage = await that.imageToBase64(defaultImage)
                }
                return API.reqCourseNoteAdd({
                    imageBase64: (isAllBlank && defaultImage) ? defaultImage : src,
                    pointIn,
                    pointOut: 0,
                    ...this.note_info,
                })
            }).then((res) => {
                if (res.statusCode === 200) {
                    noteId = res.data
                    this.$message.success("添加笔记成功");
                    this.getNoteList(res.data);
                    this.addLoading = false;
                    //直播不能抽帧
                    if (this.isLive) return Promise.resolve({ screenshotFlag: true })//通过
                    if (this.getIfPc()) return Promise.resolve({ screenshotFlag: true })
                    //移动端进入后端抽帧轮询查询结果
                    return API.reqNoteScreenshot({ contentId: this.note_info.contentId, ns100: parseInt(this.player.currentTime * 10000000), noteId: res.data })
                } else {
                    this.$message.error("添加笔记失败，请重新添加");
                    return Promise.reject()
                }
            }).then(res => {
                //screenshotFlag为true为非后端抽帧
                if (res.screenshotFlag) {
                    this.screenShotLoading = false
                    this.addLoading = false
                    return
                }
                let times = 0
                //轮询查询抽帧结果
                let interval = setInterval(() => {
                    API.reqNoteScreenshotStatus({ contentId: this.note_info.contentId, ns100: parseInt(this.player.currentTime * 10000000), noteId: noteId }).then(async (res) => {
                        // console.log('reqNoteScreenshotStatus', res)
                        if (!res.statusCode || !res.data || !res.data.length) return
                        clearInterval(interval)
                        let imageBase64 = await that.getCanvasBase64(res.data[res.data.length - 1].filePath)
                        //更新笔记截图
                        API.reqSensitiveWord(this.note_info.remark, '笔记', () => API.reqCourseNoteUpdate({
                            id: noteId,
                            imageBase64,
                            pointIn,
                            pointOut: 0,
                            ...this.note_info,
                        })).then((res) => {
                            if (res.statusCode != config.eduSuccessCode) return
                            for (let i = 0; i < this.noteList.length; i++) {
                                if (this.noteList[i].id == noteId) {
                                    this.$set(this.noteList[i], "keyframe", imageBase64);
                                    that.screenShotLoading = false
                                    break
                                }
                            }
                        }).catch(() => {
                            // that.$message.error("更新笔记截图失败");
                            return Promise.reject()
                        })
                    }).catch(() => {
                        clearInterval(interval)
                        that.screenShotLoading = false
                    })
                    if (times >= 5000) {
                        //轮询最多5s
                        clearInterval(interval)
                        that.screenShotLoading = false
                    }
                    times += 500
                }, 500)
            }).catch(err => {
                this.$message.error("笔记截图抽帧失败");
                this.screenShotLoading = false
            })
        },

        getBase64Image(img) {
            var canvas = document.createElement("canvas");
            canvas.width = img.width;
            canvas.height = img.height;

            var ctx = canvas.getContext("2d");
            ctx.drawImage(img, 0, 0, img.width, img.height);
            var ext = img.src.substring(img.src.lastIndexOf(".") + 1).toLowerCase();
            var dataURL = canvas.toDataURL("image/" + ext);
            return dataURL;
        },
        getCanvasBase64(src) {
            const that = this
            return new Promise((resolve) => {
                var image = new Image();
                image.crossOrigin = '';
                image.src = src;
                image.onload = function () {
                    var base64 = that.getBase64Image(image);
                    resolve(base64);
                }
            })
        },
        //点击笔记(添加、取消)
        editNoteHandel(index, state) {
            this.editIndex = index
            if (state) {
                //编辑新笔记关闭其他旧笔记
                for (let i = 0; i < this.noteList.length; i++) {
                    this.$set(this.noteList[i], "editState", false);
                }
            }
            this.$set(this.noteList[index], "editState", state);
            this.$nextTick(function () {
                setTimeout(() => {
                    if (state) {
                        this.$set(
                            this.noteList[index],
                            "_remark",
                            this.noteList[index].remark
                        );
                        document.querySelectorAll(".course_note_panel")[0].scrollTo({
                            top: this.$refs[`userNoteItem_${index}`][0].offsetTop - 48,
                            behavior: "smooth",
                        });
                    }
                }, 400); // 不设置setTimeout的话此时还是展开状态获取到的offsetTop偏大
            });
        },
        //保存编辑
        addNoteSubmit(index) {
            API.reqSensitiveWord(this.noteList[index]._remark, '笔记', () => API.reqCourseNoteUpdate({
                id: this.noteList[index].id,
                remark: this.noteList[index]._remark,
                pointIn: this.noteList[index].pointIn,
                semesterId: this.noteList[index].semesterId,
            })).then((res) => {
                if (res.statusCode === config.eduSuccessCode) {
                    this.$message.success("保存笔记成功");
                    this.getNoteList();
                }
            });
        },
        //删除笔记
        delNoteHandel(index) {
            API.reqCourseNoteDel([this.noteList[index].id]).then((res) => {
                if (res.statusCode === config.eduSuccessCode) {
                    this.noteList.splice(index, 1);
                    this.$emit("update:length", this.noteList.length || 0);
                    this.$message.success("删除笔记成功");
                }
            });
        },
        //视频截图
        videoScreenShot() {
            const that = this
            return new Promise((resolve, reject) => {
                if (!that.getIfPc() && !that.isLive) {
                    //移动端后端抽帧
                    return resolve(null)
                }
                try {
                    let quality = 0.6
                    if (this.player.screenshoot) {
                        //多分屏截图
                        // console.log(this.player.screenshoot().toDataURL("image/png", quality))
                        let cvs = this.player.screenshoot()
                        resolve(cvs.toDataURL("image/jpeg", quality))
                    } else {
                        var canvas = document.createElement("canvas");
                        // let quality = 0.8;
                        // canvas.width = this.player.video.videoWidth * quality;
                        // canvas.height = this.player.video.videoHeight * quality;
                        canvas.width = 1080;
                        let scale = canvas.width / this.player.video.videoWidth
                        canvas.height = this.player.video.videoHeight * scale;
                        let canvasCtx = canvas.getContext("2d");
                        canvasCtx.drawImage(
                            this.player.video,
                            0,
                            0,
                            canvas.width,
                            canvas.height
                        );
                        console.log(canvas.toDataURL("image/jpg", 0.1))
                        resolve(canvas.toDataURL("image/jpeg", quality));
                    }
                } catch {
                    resolve(null)
                }
            });
        },
        playerSeek(item) {
            const { pointIn, note } = item
            // this.player.currentTime = pointIn / 10000000;
            // this.player.play();
            let currentTime = pointIn / 10000000;
            this.$emit('seek', { currentTime, videoId: note })
        },
        //下载笔记
        handleDownloadNote() {
            let arr = this.noteList.map(el => {
                let { courseName = '', sectionName = '', resourceName = '', remark = '', keyframe = '' } = el
                return {
                    isLearn: true,
                    courseName,
                    sectionName,
                    resourceName,
                    noteContent: remark,
                    keyframe
                }
            })
            var url = "/edudatacenter/v1/learning-note-service/download"; //接口
            var xhr = new XMLHttpRequest();
            xhr.open('POST', url, true);
            xhr.responseType = "blob";  // 返回类型blob
            xhr.setRequestHeader("Content-type", "application/json;charset=utf-8"); //这个看后端接口情况决定要不要写
            // 定义请求完成的处理函数，请求前也可以增加加载框/禁用下载按钮逻辑
            xhr.onload = function () {
                // 请求完成
                if (this.status === 200) {
                    // 返回200
                    var blob = this.response;
                    // 获取服务端返回的文件名
                    var filename = '';
                    var disposition = xhr.getResponseHeader('Content-Disposition');
                    if (disposition && disposition.indexOf('attachment') !== -1) {
                        var filenameRegex = /filename\*=UTF-8''([\w%\-\.]+)(?:; ?|$)/i;
                        var matches = filenameRegex.exec(disposition);
                        if (matches != null && matches[1]) {
                            filename = decodeURIComponent(matches[1])
                            let split = filename.split('.')
                            filename = arr[0].courseName + '-' + arr[0].resourceName + '笔记.' + split[split.length - 1]
                        }
                    }
                    var reader = new FileReader();
                    reader.readAsDataURL(blob);  // 转换为base64，可以直接放入a表情href
                    reader.onload = function (e) {
                        // 转换完成，创建一个a标签用于下载
                        var a = document.createElement('a');
                        a.download = filename;
                        a.href = e.target.result;
                        jQuery("body").append(a);  // 修复firefox中无法触发click
                        a.click();
                        jQuery(a).remove();
                    }
                }
            };
            // 发送ajax请求
            xhr.send(JSON.stringify(arr))
        }
    },
    template: `
  <div class="course_note_panel">
       <div class="top_toolbar" v-if="canAddNote">
            <el-tooltip effect="dark" :disabled="has_login" :content="$t('登录后可使用笔记功能')" placement="top">
                <el-button class="add_btn" :loading="addLoading || screenShotLoading" type="primary" icon="el-icon-plus" @click="addNoteHandel">{{$t('添加笔记')}}</el-button>
            </el-tooltip>
            <el-button icon="el-icon-bottom" type="text" @click="handleDownloadNote">{{$t('下载笔记')}}</el-button>
       </div>
      <div :ref="'userNoteItem_' + i" :id="'userNoteItem_' + i" :class="{user_note_item:true,edit_active:item.editState}"
          v-for="(item,i) in noteList" :key="item.id">
          <img v-if="item.keyframe" class="user_note_cover" :src="base_url + item.keyframe" alt=""
              @click="playerSeek(item)">
          <div class="user_note_text" v-else-if="item.note" @click="playerSeek(item)">            
              <text-clamp :text="item.note" :maxLines="3" :ifInit="if_this_tab">
                  <template v-slot:default="{ clickToggle, expanded }">
                  <a @click="clickToggle" class="open_close_btn">
                      {{ expanded ? $t("收起") : $t("展开") }}
                  </a>
                  </template>
              </text-clamp>
          </div>
          <div class="user_note_panel">
              <span class="time" @click="playerSeek(item)" v-if="!isLive">
                      <i class="el-icon-video-play"></i>
                      <span>{{item.pointIn | l100Ns2Tc$1}}</span>
              </span>
              <span class="btn_group">
                  <span v-show="!item.editState">
                      <i class="el-icon-edit-outline" @click="editNoteHandel(i,true)"></i>                            
                      <el-popconfirm :title="$t('确认删除当前笔记？')" @confirm="delNoteHandel(i)">
                          <i slot="reference" class="el-icon-delete"></i>
                      </el-popconfirm>
                  </span>
                  <span v-show="item.editState">
                      <i class="el-icon-check" @click="addNoteSubmit(i)"></i>
                      <i class="el-icon-close" @click="editNoteHandel(i,false)"></i>
                  </span>
              </span>
          </div>
          <div v-show="!item.editState" class="user_note_content">{{item.remark}}</div>
          <el-input v-show="item.editState" type="textarea" autosize
              v-model="noteList[i]._remark" maxlength="200" show-word-limit>
          </el-input>
      </div>
      <el-empty v-if="!noteList.length" :description="canAddNote?$t('好记性不如烂笔头！'):$t('目前仅支持视频笔记哦～')"></el-empty>
  </div>
  `,
});